export const CUSTOMER_TRACKUNIT_CONSTRUCTION = 19329;
export const CUSTOMER_TERBERG = 17345;
